/* src/components/AffiliateLinkCTA/AffiliateLinkCTA.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	append_hydration,
	attr,
	children,
	claim_element,
	claim_space,
	claim_text,
	detach,
	element,
	init,
	insert_hydration,
	noop,
	safe_not_equal,
	set_data,
	space,
	text,
	toggle_class
} from "svelte/internal";

function create_if_block_1(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text(/*title*/ ctx[0]);
			this.h();
		},
		l(nodes) {
			p = claim_element(nodes, "P", { class: true });
			var p_nodes = children(p);
			t = claim_text(p_nodes, /*title*/ ctx[0]);
			p_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p, "class", "solar-cta__title svelte-11kh4cy");
		},
		m(target, anchor) {
			insert_hydration(target, p, anchor);
			append_hydration(p, t);
		},
		p(ctx, dirty) {
			if (dirty & /*title*/ 1) set_data(t, /*title*/ ctx[0]);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (21:2) {#if type === 'normal' && subheader}
function create_if_block(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text(/*subheader*/ ctx[1]);
			this.h();
		},
		l(nodes) {
			p = claim_element(nodes, "P", { class: true });
			var p_nodes = children(p);
			t = claim_text(p_nodes, /*subheader*/ ctx[1]);
			p_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(p, "class", "solar-cta__subheader");
		},
		m(target, anchor) {
			insert_hydration(target, p, anchor);
			append_hydration(p, t);
		},
		p(ctx, dirty) {
			if (dirty & /*subheader*/ 2) set_data(t, /*subheader*/ ctx[1]);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let t0;
	let t1;
	let a;
	let t2;
	let if_block0 = (/*type*/ ctx[5] === 'normal' || /*type*/ ctx[5] === 'inline') && /*title*/ ctx[0] && create_if_block_1(ctx);
	let if_block1 = /*type*/ ctx[5] === 'normal' && /*subheader*/ ctx[1] && create_if_block(ctx);

	return {
		c() {
			div = element("div");
			if (if_block0) if_block0.c();
			t0 = space();
			if (if_block1) if_block1.c();
			t1 = space();
			a = element("a");
			t2 = text(/*button*/ ctx[2]);
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			if (if_block0) if_block0.l(div_nodes);
			t0 = claim_space(div_nodes);
			if (if_block1) if_block1.l(div_nodes);
			t1 = claim_space(div_nodes);
			a = claim_element(div_nodes, "A", { href: true, class: true });
			var a_nodes = children(a);
			t2 = claim_text(a_nodes, /*button*/ ctx[2]);
			a_nodes.forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(a, "href", /*url*/ ctx[3]);
			attr(a, "class", "solar-cta__btn btn btn-primary");
			attr(div, "class", "solar-cta is-cta svelte-11kh4cy");
			toggle_class(div, "solar-cta--dark", /*theme*/ ctx[4] === 'dark');
			toggle_class(div, "solar-cta--inline", /*type*/ ctx[5] === 'inline');
			toggle_class(div, "solar-cta--btn-only", /*type*/ ctx[5] === 'button');
		},
		m(target, anchor) {
			insert_hydration(target, div, anchor);
			if (if_block0) if_block0.m(div, null);
			append_hydration(div, t0);
			if (if_block1) if_block1.m(div, null);
			append_hydration(div, t1);
			append_hydration(div, a);
			append_hydration(a, t2);
		},
		p(ctx, [dirty]) {
			if ((/*type*/ ctx[5] === 'normal' || /*type*/ ctx[5] === 'inline') && /*title*/ ctx[0]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					if_block0.m(div, t0);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (/*type*/ ctx[5] === 'normal' && /*subheader*/ ctx[1]) {
				if (if_block1) {
					if_block1.p(ctx, dirty);
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					if_block1.m(div, t1);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (dirty & /*button*/ 4) set_data(t2, /*button*/ ctx[2]);

			if (dirty & /*url*/ 8) {
				attr(a, "href", /*url*/ ctx[3]);
			}

			if (dirty & /*theme*/ 16) {
				toggle_class(div, "solar-cta--dark", /*theme*/ ctx[4] === 'dark');
			}

			if (dirty & /*type*/ 32) {
				toggle_class(div, "solar-cta--inline", /*type*/ ctx[5] === 'inline');
			}

			if (dirty & /*type*/ 32) {
				toggle_class(div, "solar-cta--btn-only", /*type*/ ctx[5] === 'button');
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div);
			if (if_block0) if_block0.d();
			if (if_block1) if_block1.d();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { title = '' } = $$props;
	let { subheader = '' } = $$props;
	let { button = '' } = $$props;
	let { url = '' } = $$props;
	let { theme = 'light' } = $$props;
	let { type = 'normal' } = $$props;

	$$self.$$set = $$props => {
		if ('title' in $$props) $$invalidate(0, title = $$props.title);
		if ('subheader' in $$props) $$invalidate(1, subheader = $$props.subheader);
		if ('button' in $$props) $$invalidate(2, button = $$props.button);
		if ('url' in $$props) $$invalidate(3, url = $$props.url);
		if ('theme' in $$props) $$invalidate(4, theme = $$props.theme);
		if ('type' in $$props) $$invalidate(5, type = $$props.type);
	};

	return [title, subheader, button, url, theme, type];
}

class AffiliateLinkCTA extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			title: 0,
			subheader: 1,
			button: 2,
			url: 3,
			theme: 4,
			type: 5
		});
	}
}

export default AffiliateLinkCTA;